import { useState } from 'react';
import { Button } from '../../../tailwindcomponents';
import { Typography, CircularProgress, Table, TableRow, TableCell } from '../../../tailwindcomponents';
import toolsApi from '../../../api/tools';
import { UpdateTool } from '../../../types/tool';

interface SyncMaintenerMxiToolsProps {
    setLoading: (loading: boolean) => void;
}

function SyncMaintenerMxiTools({ setLoading }: SyncMaintenerMxiToolsProps) {
    const [isUpdatedTools, setIsUpdatedTools] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [isUpdateing, setIsUpdating] = useState<boolean>(false);
    const [addedTools, setAddedTools] = useState<UpdateTool[]>([]);
    const [updatedTools, setUpdatedTools] = useState<UpdateTool[]>([]);

    const onSyncTools = () => {
        setIsUpdating(true);
        setLoading(true);
        toolsApi.UpdateToolsLocation().then(res => {
            if (res.status === true) {
                setUpdatedTools(res.updatedTools);
                setAddedTools(res.addedTools);
                setMessage(res.message);
                setIsUpdatedTools(true);
            }
            else {
                setMessage(res.message);
                setIsUpdatedTools(false);
            }
        }).catch(() => {
            setMessage("Something went wrong while syncing tools");
            setIsUpdatedTools(false);
        }).finally(() => {
            setIsUpdating(false);
            setLoading(false);
        });
    }

    const generateToolsTableBody = (row: UpdateTool, index: number) => {
        return (
            <TableRow>
                <TableCell>{index}</TableCell>
                <TableCell>{row.toolName}</TableCell>
                <TableCell>{row.toolLocation}</TableCell>
                {row.previousToolLocation && <TableCell>{row.previousToolLocation}</TableCell>}
            </TableRow>
        )
    }

    return (
        <div>
            <div className="flex flex-row flex-wrap">
                <div className="mt-4">
                    <Button variant="contained" color='primary' className="mb-8" onClick={() => onSyncTools()}>Update tool locations</Button>
                </div>
                <div className="mt-4">
                    {isUpdateing && <CircularProgress className="ml-2 mt-1" size="2rem" />}
                </div>
            </div>
            <div>
                {(isUpdatedTools && !isUpdateing) && <Typography align='center' variant='h3' text={message} margin={[0, 0, 0, 0]} />}
            </div>
            {(isUpdatedTools && !isUpdateing) &&
                <div>
                    <div className="mt-[50px]">
                        <Typography align='center' variant='h3' text={"Added tools"} />
                        <Table
                            headers={["Tool name", "Location"]}
                            rows={addedTools}
                            generateBody={(row: UpdateTool, index: number) => generateToolsTableBody(row, index)}
                            pagination={true}
                            defaultRowsPerPage={10}
                        />
                    </div>
                    <div className="mt-[100px]">
                        <Typography align='center' variant='h3' text={"Updated tools"} />
                        <Table
                            headers={["Tool name", "New location", "Old location"]}
                            rows={updatedTools}
                            generateBody={(row: UpdateTool, index: number) => generateToolsTableBody(row, index)}
                            pagination={true}
                            defaultRowsPerPage={10}
                        />
                    </div>
                </div>
            }
        </div>
    );
};

export default SyncMaintenerMxiTools;